// RequestedProduct.js
import React, { useState } from "react";
import DetailsTable from "./DetailsTable";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Table from "../../Table";
import { deleteProductItem } from "../../../../redux/reducer/productReducer";
import {
  fetchAllCarts,
  submitItemsToReceived,
} from "../../../../redux/reducer/cartReducer";
import LoadingSpinner from "../../../animation/LoadingSpinner";

const RequestedProduct = ({
  cartID,
  setEditingProducts,
  data,
  refreshData,
  loading,
}) => {
  const [editingOrder, setEditingOrder] = useState(null);
  const [pricingOrder, setPricingOrder] = useState(null);
  const [galleryEditingOrder, setGalleryEditingOrder] = useState(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // console.log(data)
  const headers = [
    "ID",
    "Prod. No",
    "Image",
    "Name",
    "Info",
    "Size",
    "Link",
    "Count",
    "Status",
    "Area",
    "total",
    "weight",
    "created At",
    "Actions",
  ];

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this Product?")) {
      dispatch(deleteProductItem(id))
        .unwrap()
        .then(() => {
          if (refreshData) refreshData();
        })
        .catch((error) => alert(error || "Failed to delete order."));
    }
  };

  const handleSubmitReceived = () => {
    if (window.confirm("Are you sure you want to Received this cart?")) {
      // console.log(cartID)
      dispatch(submitItemsToReceived(cartID))
        .unwrap()
        .then(() => {
          dispatch(fetchAllCarts(["requested"]));
          setEditingProducts(cartID);
        })
        .catch((error) => alert(error || "Failed to delete order."));
    }
  };

  const handleUpdate = (cartId) => {
    if (refreshData) refreshData();
  };

  if (loading) {
    return <LoadingSpinner />;
  }
  // console.log(data)
  return (
    <>
      <Table
        title={t("Requested Products")}
        headers={headers}
        data={data}
        EditingProducts={setEditingProducts}
        renderRow={(product, index) => (
          <DetailsTable
            key={product._id || index}
            index={index + 1}
            details={{
              id: product._id,
              number: index + 1,
              Box: product.ReferenceCode,
              link: product.link,
              info: product.additionalInfo,
              Count: product.count,
              history: product.createdAt,
              weight: product.weight || "0.0",
              price: product.price || "00.0",
              status: product.status,
              DShippingFees: product.DShippingFees || "00.0",
              category: product.category,
              brand: product.brand,
              area: product.area,
              currency: product.currency,
              name: product.name,
              image:
                product.img || "https://api.markaship.com/uploads/waiting.png",
              PackingFees: product.PackingFees || "0.0",
              images: product.imgs,
              size: product.size,
            }}
            isEditing={editingOrder === product._id}
            isGalleryEditing={galleryEditingOrder === product._id}
            isPricing={pricingOrder === product._id}
            setEditingOrder={setEditingOrder}
            setGalleryEditingOrder={setGalleryEditingOrder}
            setPricingOrder={setPricingOrder}
            onDelete={() => handleDelete(product._id)}
            onUpdate={() => handleUpdate(cartID)}
            refreshData={refreshData}
          />
        )}
      />
      <div className="flex justify-end mt-4">
        <button
          disabled={!data.every((product) => product.status === "received")}
          className={`px-4 py-2 rounded font-semibold text-black ${
            data.every((product) => product.status === "received")
              ? "bg-custom-yellow hover:bg-yellow-600"
              : "bg-yellow-200 cursor-not-allowed"
          }`}
          onClick={() => handleSubmitReceived()}
        >
          {t("Proceed")}
        </button>
      </div>
    </>
  );
};

export default RequestedProduct;
